import { useEffect, useState } from "react";
import axios from "axios";
import { toast } from "sonner";
import { AppointmentEditorDialog } from "@/components/AppointmentEditorDialog";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const ProjectAppointmentDrawer = ({ appointment, onClose, onSaved, project }) => {
  const [users, setUsers] = useState([]);

  useEffect(() => {
    axios.get(`${API}/operations/assignable-users`)
      .then((response) => setUsers(response.data.users || []))
      .catch(() => toast.error("Appointment participants could not load."));
  }, []);

  const saveAppointment = async (payload) => {
    const fixedPayload = { ...payload, project_id: project.id };
    if (appointment?.id) {
      await axios.patch(`${API}/appointments/${appointment.id}`, fixedPayload);
    } else {
      await axios.post(`${API}/appointments`, fixedPayload);
    }
    await onSaved();
    onClose();
  };

  const deleteAppointment = async (appointmentId) => {
    await axios.delete(`${API}/appointments/${appointmentId}`);
    await onSaved();
    onClose();
  };

  return (
    <AppointmentEditorDialog
      appointment={appointment}
      data-testid="project-appointment-drawer"
      defaultDate={new Date()}
      lockedProjectId={project.id}
      lockedProjectLabel={`${project.project_code} · ${project.name}`}
      onDelete={deleteAppointment}
      onOpenChange={(open) => !open && onClose()}
      onSave={saveAppointment}
      open
      projects={[]}
      users={users}
    />
  );
};